import supabase from "../supabase";

export async function logEvent(event, meta = {}) {
  const { data: auth } = await supabase.auth.getUser();
  if (!auth?.user) return;

  await supabase.from("user_events").insert({
    user_id: auth.user.id,
    event,
    meta,
  });
}